"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHoursInfo = void 0;

var _utils = require("../../utils");

var getHoursInfo = function getHoursInfo(_ref) {
  var hour = _ref.hour,
      locationInfoHour = _ref.locationInfoHour,
      diningOption = _ref.diningOption;

  if (diningOption === "delivery") {
    return {
      label: _utils.Copy.LOCATION_LIST_STATIC.DINING_OPTION_DELIVERY_LABEL,
      open: hour.deliveryOpen,
      close: hour.deliveryClose,
      displayHour: locationInfoHour.delivery
    };
  }

  return {
    label: _utils.Copy.LOCATION_LIST_STATIC.DINING_OPTION_PICKUP_LABEL,
    open: hour.pickupOpen,
    close: hour.pickupClose,
    displayHour: locationInfoHour.pickup
  };
};

exports.getHoursInfo = getHoursInfo;